export default api => ({
  login: data => api.post('auth/token', data),
  refresh_token: data => api.post('auth/token/refresh', data),
})
